// import { parse, differenceInMilliseconds } from "date-fns";
import moment from 'moment';

const DateTimeHelper = {
	/**
     * This function return in second time life token
     *
     * @param tokenExp
     * @returns {number}
     */
	getTokenTimeLife (tokenExp) {
		// const unixDate = parse(new Date()).getTime()/1000;
		// const now = parseInt(unixDate);
		// return differenceInMilliseconds(tokenExp, now);
        
		const unixDate = moment().toDate().getTime() / 1000;
		const now = parseInt(unixDate);
        
		return moment(tokenExp).diff(now);
	},
};

export default DateTimeHelper;
